
import React from "react";
import { motion } from "framer-motion";

interface DescriptionTextProps {
  description: string;
  className?: string;
}

const DescriptionText: React.FC<DescriptionTextProps> = ({
  description,
  className = "text-xs text-muted-foreground mt-1"
}) => {
  return (
    <motion.p 
      className={className}
      initial={{ opacity: 0, y: 5 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2, duration: 0.3 }}
    >
      {description}
    </motion.p>
  );
};

export default DescriptionText;
